<script setup>
const props = defineProps({
  icon: {
    type: String,
    required: false,
    default: "mdi-close",
  },
  iconSize: {
    type: String,
    required: false,
    default: "20",
  },
});

const emits = defineEmits(["onSubmitButton"]);

const submitButton = () => {
  emits("onSubmitButton");
};
</script>

<template>
  <IconBtn
    class="v-dialog-close-btn"
    aria-label="Close popup"
    data-controller-close
    @click.stop="submitButton"
    :size="props.iconSize"
  >
    <v-icon :icon="props.icon" :size="props.iconSize" />
  </IconBtn>
</template>

<style scoped lang="postcss">
.v-dialog-close-btn {
  position: absolute;
  z-index: 1;
  /* color: rgba(var(--v-theme-on-surface), var(--v-disabled-opacity)) !important; */
  inset-block-start: 1rem;
  inset-inline-end: 1rem;

  /* border-radius: 0.375rem; */
  /* background-color: rgb(var(--v-theme-surface)) !important; */
  block-size: 2rem;
  inline-size: 2rem;
  transform: translate(0.5rem, -0.5rem);

  &:hover {
    transform: translate(0.3125rem, -0.3125rem);
  }

  .v-btn__overlay {
    display: none;
  }
}
</style>
